// Ce que la carte « Stockage d'objets » dit des fichiers bruts : combien sont RÉELLEMENT présents, combien manquent.
//
// ⚠️ LA CARTE COMPTAIT LES RÉFÉRENCES DE LA BASE. En bêta, le stockage recréé vide au passage à Versity affichait
// « 1 095 fichier(s) brut(s) retenu(s) » pour un bucket qui n'en portait aucun : la sonde répondait, le compte
// venait de la base, et rien ne confrontait les deux. Le serveur confronte désormais ; cet écran ne fait que le dire.
import type { ApiMaintenanceStatus } from './api';

export interface RawIntegrityView {
  /** Lignes neutres de la carte. */
  lines: string[];
  /** Ce qui demande un geste (bruts manquants, contrôle impossible), ou `null`. */
  alert: string | null;
  /** Les premiers bruts manquants, pour aller voir lesquels. */
  missingKeys: string[];
}

/** La lecture du contrôle d'intégrité, sans rien inventer quand il n'a pas eu lieu. */
export function rawIntegrityView(status: Pick<ApiMaintenanceStatus, 'raw' | 'rawError'>): RawIntegrityView {
  const { raw, rawError } = status;
  if (!raw) {
    // ⚠️ Sans contrôle, AUCUN compte : un « 0 manquant » se lirait « tout est là ». Quand un magasin est injoignable,
    // sa propre carte dit déjà pourquoi ; seul l'échec du contrôle lui-même a besoin d'être dit ici.
    return { lines: [], alert: rawError ? `Contrôle des fichiers bruts impossible : ${rawError}` : null, missingKeys: [] };
  }
  const lines = [`${raw.present} fichier(s) brut(s) présent(s) sur ${raw.referenced} référencé(s)`];
  if (raw.missing === 0) return { lines, alert: null, missingKeys: [] };
  return {
    lines,
    alert: `${raw.missing} message(s) référencent un fichier brut ABSENT du stockage : ni rejeu ni téléchargement possibles pour eux.`,
    missingKeys: raw.missingSample.map((m) => m.rawRef),
  };
}
